import {
  Component,
  ComponentInterface,
  Event,
  EventEmitter,
  h,
  Prop,
} from '@stencil/core';

@Component({
  shadow: true,
  styleUrl: 'paf-toggle-checkbox.scss',
  tag: 'paf-toggle-checkbox',
})

export class PafToggleCheckbox implements ComponentInterface {

  /**
   * The value for the checkbox
   */
  @Prop() public value!: string;

  /**
   * The name for the checkbox
   */
  @Prop() public name!: string;

  /**
   * The text to show as label.
   */
  @Prop() public label!: string;

  /**
   * Define if it should be checked
   */
  @Prop() public checked?: boolean;

  /**
   * Event which is emitted when the value of the toggle changes
   */
  @Event({
    bubbles: true,
    composed: true,
    eventName: 'paf-toggle-checkbox_changed',
  })
  public changed: EventEmitter<boolean>;

  private _onChange = (evt): void => {
    evt.preventDefault();
    evt.stopPropagation();

    this.changed.emit(evt.target.checked);
  };

  public render(): HTMLDivElement {
    const inputAttributes = {};

    if (this.checked) {
      inputAttributes['checked'] = true;
    }

    return (
      <div class='wrapper'>
        <input
          class='input'
          type='checkbox'
          name={this.name}
          value={this.value}
          id={this.value}
          onChange={this._onChange}
          {...inputAttributes}
          data-testid='input'
        />

        <label
          class='label'
          htmlFor={this.value}
          data-testid='label'
        >{this.label}</label>
      </div>
    );
  }
}
